import React from 'react';
import Demo from '.././../assets/macbook-demo.png'
import './ripple.css';
function Ripple() {
    return ( 
        <div className="ripple" id="ripple">
            <div className="ripple__content">
                <h1>
                Build Your Dreams  in a Matter of Seconds with ES Manager
                </h1>
                <p>Whether you're crafting the next big software application or launching a captivating website, ES Manager provides the integrated environment you need. Accelerate development, streamline deployment, and manage your digital assets with tools designed for both versatility and performance.</p>
                <h2>Start Building your Future Now</h2>

                <div className='ripple__btns d-flex align-items-center gap-4'>
                    <button><a href='https://www.es.manager.com'>Get Started</a></button>
                </div>
                    
            </div>
            <div className="ripple__image">
                <img src={Demo} alt='demo' loading="lazy"/>
            </div>
        </div>
    )
}

export default Ripple;
